import {
    DEAL_LIST_REQUEST,
    DEAL_LIST_SUCCESS,
    DEAL_LIST_FAIL,
} from '../constants/dealConstants'
import api from '../core/api'

export const listDeal = (Id) => async (dispatch, getState) => {
    try{
        dispatch({ type: DEAL_LIST_REQUEST })

        const { data } = await api.get(
            "/deal/getTotalDeals/" + Id,
        )

        var dt = data.Result;
        if(typeof(dt) == 'string'){
            dispatch({
                type: DEAL_LIST_FAIL,
                payload: data.Result
            })
        }else{
            dispatch({
                type: DEAL_LIST_SUCCESS,
                payload: data.Result
            })
        }

        
    }
    catch(error){
        dispatch({
            type: DEAL_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}